import { cn } from '../../lib/cn';
import type { DecisionRow } from '../../executiveintel/framework';

type Props = { decisions?: DecisionRow[] };

export function DecisionEnginePanel({ decisions = [] }: Props) {
  return (
    <div className="space-y-2">
      {decisions.map((d) => (
        <div key={d.title} className="flex items-start justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium">{d.title}</p>
            <p className="mt-0.5 text-xs text-success-600">{d.impact} · ROI {d.roi}</p>
          </div>
          <div className="shrink-0 text-right">
            <p className={cn(
              'text-lg font-semibold',
              d.priority >= 90 ? 'text-error-600' : d.priority >= 80 ? 'text-warning-600' : 'text-brand-600',
            )}>
              P{d.priority}
            </p>
            <p className="text-xs text-slate-500">{d.confidence}% conf</p>
          </div>
        </div>
      ))}
    </div>
  );
}
